export default __webpack_public_path__ + "static/media/edital 8 - Aprovados Preliminarmente e Convocação.55892a2f.pdf";